import { IErrorLoggerWithUserSupport } from '@verv-inc/js-toolkit/core-logs/lib/ErrorLoggerWithUserSupport';

import { IEveryDoggyAPIServices } from '../../../../utils/services/EveryDoggyAPIServices';
import {
  IStripeViewModel,
  composeStripeCheckoutViewModel,
} from '../../../../utils/payments/stripeCheckoutViewModel';
import { GTMQuizFunnelEvent } from '../../../../utils/analytics';

export type { IStripeViewModel };

/** Main paywall checkout: success is tracked as the quiz-funnel `paymentSuccessful`. */
function ComposeStripeViewModel(
  sourceURL: string,
  stripePlanID: string,
  apiServices: IEveryDoggyAPIServices,
  errorLogger: IErrorLoggerWithUserSupport,
  internalId: string
): IStripeViewModel {
  return composeStripeCheckoutViewModel(
    sourceURL,
    stripePlanID,
    apiServices,
    errorLogger,
    internalId,
    ({ productName, amount, email }) =>
      GTMQuizFunnelEvent.paymentSuccessful({
        paymentType: 'stripe',
        trialPrice: amount,
        productName,
        email,
      })
  );
}

export default ComposeStripeViewModel;
